import React from "react";
import { useNavigate } from "react-router-dom";
import { Eyebrow, Btn } from "../components/Primitives";

export default function PaymentCancel() {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-cream px-7 text-center" data-testid="payment-cancel-screen">
            <Eyebrow>Checkout canceled</Eyebrow>
            <h1 className="mt-4 font-display text-3xl text-burgundy">
                <span className="italic">No charge</span> was made.
            </h1>
            <p className="mt-3 text-sm text-ink-muted max-w-sm">
                Your Founding 100 spot isn't reserved until payment completes. You can pick up right where you left off.
            </p>
            <div className="mt-8">
                <Btn data-testid="payment-cancel-back-btn" onClick={() => navigate("/")}>
                    Back to Ever After
                </Btn>
            </div>
        </div>
    );
}
